import { GetServerSideProps } from 'next';

import { wrapper } from 'src/redux/store/store';
import MainContainer from 'components/MainContainer';
import { calculateCustomerType } from 'lib/session.service';
import { PageSetUpInStorageConfig, ServerSideRenderingContext } from 'types/objectTypes';
import { SentryWrapper } from 'lib/sentry';
import { CustomerType } from 'constants/enums';
import { getHoroscopeSignsPage } from 'src/api/pageApi';
import { setUpPageInStore } from 'lib/page.service';
import withMiddleware, { commonMiddleware } from 'src/shared/lib/middleware/combiner';

const handler = async ({
  params,
  req,
  res,
  store,
  preview = false,
}: ServerSideRenderingContext): Promise<any> => {
  const session = req?.session?.getSession();
  const customerType = calculateCustomerType(req.session);

  const isAuthorized = customerType === CustomerType.AC;
  try {
    const { signName: slug } = params || { slug: '' };

    const page = await getHoroscopeSignsPage(
      { slug: slug as string, customerType, preview },
      req.cookies,
    );

    if (page) {
      const pageSetUpConfig: PageSetUpInStorageConfig = {
        page,
        session,
        slug: slug as string,
        store,
        headers: req.headers,
        isAuthorized,
      };
      setUpPageInStore(pageSetUpConfig);
      res.setHeader(
        'Cache-Control',
        'public, s-maxage=120, stale-while-revalidate=480',
      );

      return { props: {} };
    }

    return { notFound: true };
  } catch (e) {
    SentryWrapper.captureException(e);

    return { props: { } };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
  // @ts-ignore
  .getServerSideProps(withMiddleware(handler, { prior: commonMiddleware }));

export default MainContainer;
